import * as React from 'react';
import Img from 'gatsby-image';
import { Container } from 'components/UI/Container/Container';
import { LrLogo } from 'components/Icons/LrLogo';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { homepageLink } from '../../../helpers';
import { PrismicLink } from '../../PrismicLink';
import { PrismicRichTextFieldType } from '../types';
import { PricingPlanEnum } from '../../../enum';
import { SignupProps, SupportedURLParams, SignupSlice, UTMSourceMessage } from '.';

const getPlanCopy = (
    params: SupportedURLParams,
    slice: SignupSlice,
): PrismicRichTextFieldType | null => {
    const copy = slice.primary.signup_copy && slice.primary.signup_copy.document[0].data;
    let result;

    if (copy) {
        switch (params.plan) {
            case PricingPlanEnum.basic:
                result = copy.description_basic_plan;
                break;
            case PricingPlanEnum.advanced:
                result = copy.description_advanced_plan;
                break;
            case PricingPlanEnum.pro:
                result = copy.description_pro_plan;
                break;
        }
    }

    return result || null;
};

const SignupImage = (props: SignupProps) => {
    const slice = props.slice.primary;
    const items = props.slice.items || [];
    const item = items[0] || {};
    const { iframeURL } = props;
    const image = item.signup_image;
    const signupText = item.signup_text || ({} as PrismicRichTextFieldType);
    const planCopy = getPlanCopy(props.params, props.slice);

    return (
        <Container className="Signup SignupImage" data-testid="signupImage">
            <div className="Wrapper-form">
                <div className="Form">
                    <PrismicLink link={homepageLink(props.context.pageContext.lang)}>
                        <LrLogo />
                    </PrismicLink>
                    <PrismicHTMLParser className="Signup-title">
                        {slice.signup_title.html || ''}
                    </PrismicHTMLParser>
                    <PrismicHTMLParser
                        className={
                            planCopy ? 'Signup-content Signup-content-withPlan' : 'Signup-content'
                        }
                    >
                        {(planCopy && planCopy.html) || slice.signup_content.html || ''}
                    </PrismicHTMLParser>
                    {slice.signup_source_message && (
                        <UTMSourceMessage params={props.params} msg={slice.signup_source_message} />
                    )}
                    {iframeURL && (
                        <iframe
                            id="iframeForm"
                            src={iframeURL}
                            frameBorder="0"
                            height="550px"
                            width="100%"
                        />
                    )}
                </div>
            </div>
            <div className="Wrapper-medias">
                {image && image.localFile && image.localFile.childImageSharp && (
                    <Img
                        sizes={image.localFile.childImageSharp.sizes}
                        alt={signupText.text || ''}
                    />
                )}
                <PrismicHTMLParser className="Quote">{signupText.html || ''}</PrismicHTMLParser>
            </div>
        </Container>
    );
};

export { SignupImage };
